
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3_1940)","fill":"#262626"}},[_c('path',{attrs:{"d":"M11.667 18.667h-10.5A1.17 1.17 0 010 17.5V1.167A1.17 1.17 0 011.167 0h10.5a1.17 1.17 0 011.166 1.167V17.5a1.17 1.17 0 01-1.166 1.167zm-9.334-2.334H10.5v-14H2.333v14zM26.833 28h-10.5a1.17 1.17 0 01-1.166-1.167V10.5a1.17 1.17 0 011.166-1.167h10.5A1.17 1.17 0 0128 10.5v16.333A1.17 1.17 0 0126.833 28zM17.5 25.667h8.167v-14H17.5v14zM26.833 7h-10.5a1.17 1.17 0 01-1.166-1.167V1.167A1.17 1.17 0 0116.333 0h10.5A1.17 1.17 0 0128 1.167v4.666A1.17 1.17 0 0126.833 7zM17.5 4.667h8.167V2.333H17.5v2.334zM11.667 28h-10.5A1.17 1.17 0 010 26.833v-4.666A1.17 1.17 0 011.167 21h10.5a1.17 1.17 0 011.166 1.167v4.666A1.17 1.17 0 0111.667 28zm-9.334-2.333H10.5v-2.334H2.333v2.334z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3_1940"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    